var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryCy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_9850)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_9850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_9850)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0002 3.33341C20.3633 3.15186 20.7318 3.56932 20.5066 3.90709L20.0674 4.56588C20.023 4.63247 19.9659 4.6896 19.8993 4.73399L18.0551 5.96346C18.0186 5.98782 17.9845 6.01572 17.9535 6.04676L17.8049 6.19534C17.5446 6.45569 17.5446 6.8778 17.8049 7.13815L18.1954 7.52868C18.4558 7.78903 18.4558 8.21114 18.1954 8.47149L17.6733 8.99365C17.4704 9.19655 17.1604 9.24686 16.9037 9.11853L16.5964 8.96489C16.2671 8.80023 15.8667 8.93371 15.702 9.26303L15.457 9.75309C15.3779 9.91124 15.2393 10.0315 15.0715 10.0874L13.4361 10.6325C13.3682 10.6552 13.297 10.6667 13.2253 10.6667H12.4122C12.1597 10.6667 11.9288 10.8094 11.8159 11.0353L11.6316 11.4038C11.467 11.7331 11.0665 11.8666 10.7372 11.7019L8.76359 10.7151C8.6995 10.6831 8.641 10.6409 8.59033 10.5902L7.52876 9.52868C7.40373 9.40365 7.3335 9.23408 7.3335 9.05727V8.47149C7.3335 8.21114 7.54455 8.00008 7.8049 8.00008C7.92992 8.00008 8.04983 7.95042 8.13823 7.86201L9.13823 6.86201C9.26326 6.73699 9.43283 6.66675 9.60964 6.66675H10.1863C10.4733 6.66675 10.728 6.48313 10.8188 6.2109L11.1474 5.22507C11.2537 4.90611 11.5809 4.71623 11.9106 4.78217L14.5198 5.30401C14.6166 5.32337 14.7165 5.321 14.8123 5.29706L17.2625 4.6845C17.3097 4.6727 17.3554 4.65577 17.399 4.63402L18.6668 4.00008L20.0002 3.33341Z",
    fill: "#E7832C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0002 16.0001C14.3684 16.0001 14.6668 15.7016 14.6668 15.3334C14.6668 14.9652 14.3684 14.6667 14.0002 14.6667C13.632 14.6667 13.3335 14.9652 13.3335 15.3334C13.3335 15.7016 13.632 16.0001 14.0002 16.0001Z",
    fill: "#445128"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M16 14.6666C16 14.6666 18 14 18.6667 12.6666",
    stroke: "#445128",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M12 14.6666C12 14.6666 10 14 9.33333 12.6666",
    stroke: "#445128",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_9850"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryCy);
export default __webpack_public_path__ + "static/media/Country=CY.63451682bf719e87c7b86e9993fb4794.svg";
export { ForwardRef as ReactComponent };